import FeatureFlags, { initializeFeatureFlags, handleLogin, handleLogout } from './FeatureFlags';
import FeatureFlagKeys from './FeatureFlagKeys';
import { withFlagLoader } from './FlagLoader';

export { FeatureFlagKeys, withFlagLoader, initializeFeatureFlags, handleLogin, handleLogout };
export default FeatureFlags;
